<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>

          <page-title :title="pageTitle" class="text-center" />
          <hr />

          <b-row>
            <b-col md="2"></b-col>
            <b-col md="8">
              <div v-show="!stripeSubscriptionDetails">
                <b-alert v-if="error" show variant="danger"><span v-html="error"></span></b-alert>
                <div v-if="!error" class="text-center">
                  <p>Loading payment information...</p>
                </div>
              </div>
              <div v-show="stripeSubscriptionDetails">
                <div class="text-center">
                  <p>Please provide the following information.</p>
                </div>
                <b-row>
                  <b-col md="3"></b-col>
                  <b-col md="6">
                    <b-form @submit.prevent="onSubmit">
                      <b-alert v-if="error" show variant="danger"><span v-html="error"></span></b-alert>

                      <text-control v-model="paymentMethodDetails.name" label="Name" required />
                      <text-control v-model="paymentMethodDetails.line1" label="Address Line 1" required />
                      <text-control v-model="paymentMethodDetails.line2" label="Address Line 2" />
                      <text-control v-model="paymentMethodDetails.city" label="City" required />
                      <select-list-control v-model="paymentMethodDetails.state" label="State" :options="states"></select-list-control>
                      <text-control v-model="paymentMethodDetails.postal_code" label="ZIP Code" required />

                      <b-form-group label="Credit Card">
                        <div class="form-control stripe-card-container">
                          <div ref="card"></div>
                        </div>
                      </b-form-group>

                      <hr />

                      <div class="mt-3">
                        <b-button type="submit" variant="primary" :disabled="isUpdating">
                          <b-spinner small v-if="isUpdating"></b-spinner>
                          Update Payment Method
                        </b-button>
                      </div>

                    </b-form>
                  </b-col>
                </b-row>
              </div>

            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
// This tells ESLint that there's a global var named "Stripe", which comes from the Stripe SDK
/*global Stripe*/

import AuthMixin from '../Mixins/AuthMixin.vue';
import SubscriptionMixin from '../Mixins/SubscriptionMixin.vue';
import axios from "axios";
import Constants from '../Common/Constants.js';

let stripeKey = 'pk_live_51H3CVrCDuMoiniEpeAsxeoBj34g1zGLwOqZ0cdFeTSmONlGab4VMSfKTAFHspYQGCUMOJanfhOUJZT3706DkU6Ka00VdXJvqNG';
if (window.location.hostname.toLowerCase() != 'app.justicestory.com')
  stripeKey = 'pk_test_51H3CVrCDuMoiniEppca8otprdMcuM4Cfp8tMIwY1zcnOyrX3wybTQ5cjfX9FsltQOa3b9jXtjvP34fAp2xm6uKZY00jZIMHUzZ';

let isStripeLoaded = (typeof Stripe !== 'undefined');
if (!isStripeLoaded)
  console.log('Stripe is not loaded');

let stripe = isStripeLoaded ? Stripe(stripeKey) : null;
let elements = isStripeLoaded ? stripe.elements() : null;
let style = {
  base: {
    color: "#32325d",
    //fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontFamily: '"Spectral", Georgia, "Times New Roman", Times, serif',
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4"
    }
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a"
  }
};

let cardElement = isStripeLoaded ? elements.create("card", { style: style }) : null;

export default {
  name: "Subscribe",
  mixins: [AuthMixin, SubscriptionMixin],
  props: {},
  data() {
    return {
      pageTitle: 'Change Payment Method',
      error: null,
      stripeSubscriptionDetails: null,
      isUpdating: false,
      states: Constants.states,
      paymentMethodDetails: {
        subscriptionId: null,
        paymentMethodId: null,
        name: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        postal_code: '',
      },
    }
  },
  computed: {
  },
  methods: {

    loadSubscriptionUser: function () {
      axios({
        url: '/api/subscriptionUser?includes=subscription&filter=' + encodeURIComponent('applicationUserId="' + this.$root.$data.authenticatedUser.id + '"'),
        method: 'GET'
      }).then((response) => {
        let subscriptionUser = null;

        if (!response.data || response.data.length < 1) {
          this.error = 'Unable to load payment method'
          this.stripeSubscriptionDetails = null;
        } else {
          subscriptionUser = response.data[0];

          axios({
            url: '/api/subscription/' + subscriptionUser.subscription.id + '/stripeDetails',
            method: 'GET'
          }).then((response) => {
            this.stripeSubscriptionDetails = response.data;

            this.paymentMethodDetails = {
              subscriptionId: subscriptionUser.subscription.id,
              name: this.stripeSubscriptionDetails.name,
              line1: this.stripeSubscriptionDetails.line1,
              line2: this.stripeSubscriptionDetails.line2,
              city: this.stripeSubscriptionDetails.city,
              state: this.stripeSubscriptionDetails.state,
              postal_code: this.stripeSubscriptionDetails.postalCode
            };

          });
        }
      });

    },

    onSubmit: function () {
      this.isUpdating = true;

      stripe.createPaymentMethod({
        type: 'card',
        card: cardElement
      })
      .then(result => {
        console.log(result);

        if (result.error) {
          this.error = result.error.message;
          return;
        }

        this.error = null;

        this.paymentMethodDetails.paymentMethodId = result.paymentMethod.id;

        axios
          .post('/api/subscription/updatePaymentMethod', this.paymentMethodDetails)
          .then(response => {
            console.log(response);

            this.$parent.showToast('Your payment method has been updated. Thank you!', {
              title: 'Saved',
              variant: 'success',
              autoHideDelay: 5000
            });

            this.$router.push('/subscriber/manageSubscription');

            this.isUpdating = false;
          })
          .catch(error => {
            console.log(error);

            this.error = error;

            this.isUpdating = false;
          });

      });
    }
  },
  watch: {
  },
  created() {
  },
  async mounted () {
    cardElement.mount(this.$refs.card);
    this.loadSubscriptionUser();
  }
};
</script>